import { GetServerSideProps } from 'next';
import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';
import { PropsWithChildren, useEffect } from 'react';
import HeaderWithBackButton from '@/components/HeaderWithBackButton';
import CameraIcon from '@/components/icons/CameraIcon';
import CaretDownIcon from '@/components/icons/CaretDownIcon';
import MessageIcon from '@/components/icons/MessageIcon';
import Paragraph, { VARIANT } from '@/components/Paragraph';
import useTriggerEvents from '@/hooks/useTriggerEvents';
import CustomEventTypes from '@/utils/analytics/customEventTypes';
interface QuestionLinkProps {
  className?: string;
  href: string;
  text: string;
}
const QuestionLink = ({
  children,
  className = '',
  href,
  text
}: PropsWithChildren<QuestionLinkProps>) => {
  return <Link className={`border border-primary-100 flex gap-4 items-center p-4 rounded-lg ${className}`} href={href} data-sentry-element="Link" data-sentry-component="QuestionLink" data-sentry-source-file="ask-help.tsx">
      <div className="bg-neutral-20 grow-0 h-12 p-2 rounded-full shrink-0 w-12">
        {children}
      </div>
      <Paragraph className="grow text-primary-100" variant={VARIANT.BIG} data-sentry-element="Paragraph" data-sentry-source-file="ask-help.tsx">
        {text}
      </Paragraph>
      <CaretDownIcon className="fill-transparent grow-0 h-5 -rotate-90 shrink-0 stroke-2 stroke-primary-100" data-sentry-element="CaretDownIcon" data-sentry-source-file="ask-help.tsx" />
    </Link>;
};
const AskHelpPage = () => {
  const {
    t
  } = useTranslation('askQuestion');
  const {
    trackCustomEvent
  } = useTriggerEvents();
  useEffect(() => {
    const timer = setTimeout(() => {
      trackCustomEvent(CustomEventTypes.ASK_HELP_USER_LANDED);
    }, 500);
    return () => clearTimeout(timer);
  }, []);
  return <main className="bg-neutral-10 min-h-screen" data-sentry-component="AskHelpPage" data-sentry-source-file="ask-help.tsx">
      <HeaderWithBackButton heading={t('select_option')} data-sentry-element="HeaderWithBackButton" data-sentry-source-file="ask-help.tsx" />
      <section className="bg-white m-auto max-w-7xl min-h-screen py-16 w-full">
        <div className="m-auto max-w-sm p-4">
          <QuestionLink href="/ask-question" text={t('take_pic_get_soln')} data-sentry-element="QuestionLink" data-sentry-source-file="ask-help.tsx">
            <CameraIcon className="fill-primary-100" data-sentry-element="CameraIcon" data-sentry-source-file="ask-help.tsx" />
          </QuestionLink>
          <QuestionLink className="mt-8" href="/ask-agri-question" text={t('other_questions')} data-sentry-element="QuestionLink" data-sentry-source-file="ask-help.tsx">
            <MessageIcon className="fill-primary-100 h-6 m-auto mt-1 w-6" data-sentry-element="MessageIcon" data-sentry-source-file="ask-help.tsx" />
          </QuestionLink>
        </div>
      </section>
    </main>;
};
export const getServerSideProps: GetServerSideProps<{
  title: string;
}> = async () => ({
  props: {
    title: 'Ask Help'
  }
});
export default AskHelpPage;